import { useContext } from "react";
import { GraffitiContext } from "../context/GraffitiContext";

const useGraffiti = () => {
  return useContext(GraffitiContext);
};

export default useGraffiti;
